import React from 'react';
import PropTypes from 'prop-types';

import { Polyline, Marker, Map, WaypointCircle } from '@strava/ui/Map';

// Static Assets
import secondaryStartMarker from 'components/map/images/map-marker-range-start.png';
import secondaryEndMarker from 'components/map/images/map-marker-range-end.png';

import FitBounds from 'components/map/FitBounds';
import PrivacyZones from 'components/map/PrivacyZones';
import StyleNav from 'components/map/StyleNav';

// Stylesheets
import styles from './styles.scss';

function RangeSelectMap({
  currentStep = 1,
  primaryLatLng,
  secondaryLatlng = [],
  fitBounds = [],
  privacyZones = []
}) {
  const showSecondaryLine = secondaryLatlng.length > 0;

  return (
    <Map
      latLng={primaryLatLng}
      className={styles.map}
      options={{
        minZoom: 9,
        maxZoom: 18
      }}
    >
      <StyleNav />

      {fitBounds.length > 0 && (
        <FitBounds
          latlng={fitBounds}
          start={fitBounds[0]}
          end={fitBounds.slice(-1)[0]}
          updateOnLatlngChange={currentStep === 2}
        />
      )}

      {privacyZones.length > 0 && (
        <PrivacyZones
          zones={privacyZones}
          start={secondaryLatlng[0]}
          end={secondaryLatlng.slice(-1)[0]}
        />
      )}

      <Polyline
        latLng={primaryLatLng}
        id="primary-polyline"
        style={{
          lineColor: '#105CB6',
          outlineWidth: 5
        }}
      />

      <Polyline
        latLng={secondaryLatlng}
        id="secondary-polyline"
        style={{
          lineColor: '#fc5200',
          outlineWidth: 0,
          opacity: currentStep === 2 ? 0.75 : 1
        }}
      />

      {/* Primary markers */}
      <Marker latLng={primaryLatLng[0]}>
        {currentStep === 1 ? (
          <WaypointCircle type="start" />
        ) : (
          <img
            src={secondaryStartMarker}
            alt="Start"
            className={styles.secondaryMarker}
          />
        )}
      </Marker>
      <Marker latLng={primaryLatLng.slice(-1)[0]}>
        {currentStep === 1 ? (
          <WaypointCircle type="end" />
        ) : (
          <img
            src={secondaryEndMarker}
            alt="End"
            className={styles.secondaryMarker}
          />
        )}
      </Marker>

      {/* Secondary markers */}
      {showSecondaryLine && (
        <Marker latLng={secondaryLatlng[0]}>
          {currentStep === 1 ? (
            <img
              src={secondaryStartMarker}
              alt="Start"
              className={styles.secondaryMarker}
            />
          ) : (
            <WaypointCircle type="start" />
          )}
        </Marker>
      )}
      {showSecondaryLine && (
        <Marker latLng={secondaryLatlng.slice(-1)[0]}>
          {currentStep === 1 ? (
            <img
              src={secondaryEndMarker}
              alt="End"
              className={styles.secondaryMarker}
            />
          ) : (
            <WaypointCircle type="end" />
          )}
        </Marker>
      )}
    </Map>
  );
}

RangeSelectMap.propTypes = {
  currentStep: PropTypes.number,
  primaryLatLng: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number))
    .isRequired,
  secondaryLatlng: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
  privacyZones: PropTypes.arrayOf(PropTypes.shape()),
  fitBounds: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number))
};

export default RangeSelectMap;
